import type { ReactNode } from 'react';

import DefaultCard from '../../../../components/default/DefaultCard';
import QuoteForm from '../forms/QuoteForm';
import ButtonSaveForm from '../../../../components/buttons/ButtonSaveForm';
import LazyLoading from '../../../../components/LazyLoading';
import DefaultCreatedModifiedUserForm from '../../../../components/default/DefaultCreatedModifiedUserForm';
import {
    QuoteDataForm,
    QuoteOfferTypeDataForm,
    QuoteReferenceDataForm,
    QuoteShowDataForm
} from '../../../../app/models/Quote';
import { Society } from '../../../../app/models/Society';
import { Currency } from '../../../../app/models/Currency';
import { PaymentCondition } from '../../../../app/models/PaymentCondition';
import type { SectorBusinessRulesEnum } from '../../../../app/shared/enums';
import { Client } from '../../../../app/models/Client';
import QuoteShowForm from '../forms/QuoteShowForm';
import { Sector } from '../../../../app/models/Sector';
import { ClientContact } from '../../../../app/models/ClientContact';
import { useEffect, useState } from 'react';

interface Props {
    update?: () => void;
    quoteForm?: QuoteDataForm;
    quoteShowForm?: QuoteShowDataForm;
    setQuoteForm?: (quote: QuoteDataForm) => void;
    societies?: Society[];
    clients?: Client[];
    currencies?: Currency[];
    paymentConditions?: PaymentCondition[];
    references?: QuoteReferenceDataForm[];
    offerTypes?: QuoteOfferTypeDataForm[];
    paymentMethods?: PaymentCondition[];
    sectors?: Sector[];
    // Ajustado: acepta un único enum/string opcional
    sectorBusinessRulesEnum?: SectorBusinessRulesEnum | string;
    errorFields?: Record<string, unknown>;
    condition?: boolean;
    fetchingQuote?: boolean;
    fetchingQuoteInvoicing?: boolean;
    isFormShow?: boolean;
    disableUpdate?: boolean;
    loadingClient?: boolean;
    loadingSector?: boolean;
    isEdit?: boolean;
    clientContacts?: ClientContact[];
    
    updateSignal?: number

}

const QuoteTab = ({
    update,
    quoteForm,
    quoteShowForm,
    setQuoteForm,
    societies,
    clients,
    paymentMethods,
    references,
    offerTypes,
    currencies,
    sectors,
    clientContacts,
    errorFields,
    condition,
    fetchingQuote,
    isFormShow = false,
    disableUpdate = false,
    loadingClient,
    isEdit,
    updateSignal,
    fetchingQuoteInvoicing,
    sectorBusinessRulesEnum
    
}: Props) => {

    const [forceUpdate, setForceUpdate] = useState(0);

    // 4. useEffect QUE "ESCUCHA" CAMBIOS EN fetchingQuoteInvoicing
    useEffect(() => {
        // Esta función se ejecuta cada vez que cambian las dependencias
        
        // CONDICIÓN: Solo actuar cuando:
        // - fetchingQuoteInvoicing es false (ya terminó de cargar/actualizar)
        // - Y existe updateSignal (hubo una actualización de facturación)
        if (fetchingQuoteInvoicing === false && updateSignal) {
            
            console.log('Facturación actualizada, refrescando usuarios...');
            
            // ACCIÓN: Incrementar el contador para forzar re-render
            setForceUpdate(prev => prev + 1);
        }
        
    }, [fetchingQuoteInvoicing, updateSignal]); 

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <DefaultCard>
                        <div className="h3 mt-0 mb-2 card-title">Datos Generales</div>
                        {!fetchingQuote  ? (
                            <>
                                {!isFormShow ? (
                                    <>
                                        <QuoteForm
                                            quoteForm={quoteForm!}
                                            setQuoteForm={setQuoteForm!}
                                            societies={societies!}
                                            clients={clients!}
                                            references={references!}
                                            paymentMethods={paymentMethods!}
                                            offerTypes={offerTypes!}
                                            currencies={currencies!}
                                            sectors={sectors!}
                                            clientContacts={clientContacts!}

                                            errorFields={errorFields}
                                            condition={condition}
                                            disableUpdate={disableUpdate}
                                            loadingClient={loadingClient}
                                            isEdit= {isEdit}
                                        />
                                        <div className="row justify-content-end">
                                            <div className="col-auto">
                                                {
                                                // auth?.roles &&
                                                //     (auth?.roles.includes(
                                                //         Roles.OPERATIONS_MANAGER
                                                //     ) ||
                                                //         auth.roles.includes(Roles.MANAGERS)) &&
                                                !disableUpdate && (
                                                    <ButtonSaveForm callbackSave={update!} />
                                                )}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <QuoteShowForm quoteForm={quoteShowForm!} />
                                )}
                            </>
                        ) : (
                            <LazyLoading />
                        )}
                    </DefaultCard>
                </div>
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="h3 mt-0 mb-2 card-title">Usuarios</div>
                            {!fetchingQuote  ? (
                                <DefaultCreatedModifiedUserForm
                                    createdBy={
                                        !isFormShow
                                            ? quoteForm!.created_user
                                            : quoteShowForm!.created_user
                                    }
                                    createdAt={
                                        !isFormShow
                                            ? quoteForm!.created_at
                                            : quoteShowForm!.created_at
                                    }
                                    updatedBy={
                                        !isFormShow
                                            ? quoteForm!.last_modified_user
                                            : quoteShowForm?.last_modified_user
                                    }
                                    updatedAt={
                                        !isFormShow
                                            ? quoteForm!.updated_at
                                            : quoteShowForm!.updated_at
                                    }
                                    status={!isFormShow ? quoteForm!.status : quoteShowForm!.status}
                                    key={`${updateSignal}-${forceUpdate}`} // ← Combinar ambas señales
                                />
                            ) : (
                                <LazyLoading />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QuoteTab;
